import { createButton, type ClickProps } from './createButton';

export const RefreshButton = createButton<ClickProps>({
  className:
    'flex shrink-0 items-center gap-1 rounded-lg border border-red-500/25 bg-red-500/10 px-2.5 py-1 text-[12px] font-medium text-red-300 transition-colors hover:bg-red-500/20',
  content: 'Refresh',
});
